import { useEffect, useState } from 'react'
import { TestTokenResponse } from '../Api/models'
import { testUserToken } from '../Api/Api';
import { UserResponse } from '../Api/User/models';
import toast from 'react-hot-toast';

export const useTestToken = () => {
    const [userInfo, setUserInfo] = useState<UserResponse | null>(null)
    const [loadingConnection, setLoadingConnection] = useState(false)
    const [connected, setConnected] = useState(false)

    const testToken = async () => {
        setLoadingConnection(true)
        const result: TestTokenResponse = await testUserToken();
        if (!result?.data?.status) {
            setConnected(false)
            toast.error('Hubo un error al conectar con la plataforma')
            // Cookies.remove('Token')
            // navigate('/login');
        } else {
            setConnected(true)
            setUserInfo(result?.data?.user)
        }

        setLoadingConnection(false)
    };

    useEffect(() => {
        testToken()
    }, [])

    return {
        userInfo,
        connected,
        testToken,
        loadingConnection
    }
}
